import "./index.scss";
import { Button } from "components/UI/atoms";
import { ReactComponent as PhoneIcon } from "assets/phone-icon.svg";
import { ReactComponent as SpeechIcon } from "assets/speech-icon.svg";
import { ReactComponent as ChevronArrow } from "assets/chevron-arrow.svg";
import { VERIFICATION_METHODS } from "constants/verificationMethods";

export const DeviceVerificationButtons = ({ method, phone, sendCode }) => (
  <div className="device-verification-buttons">
    {method && <p>Didn't receive a verification code? Please try again:</p>}
    <Button
      customClassName="verification-button"
      onClick={() => sendCode(VERIFICATION_METHODS.CALL)}
    >
      <PhoneIcon />
      <p>
        {method === VERIFICATION_METHODS.CALL ? "CALL AGAIN" : "CALL"} (XXX)
        XXX-X{phone.slice(-3)}
      </p>
      <ChevronArrow />
    </Button>
    <Button
      customClassName="verification-button"
      onClick={() => sendCode(VERIFICATION_METHODS.TEXT)}
    >
      <SpeechIcon />
      <p>
        {method === VERIFICATION_METHODS.TEXT ? "RESEND CODE" : "TEXT"} (XXX)
        XXX-X{phone.slice(-3)}
      </p>
      <ChevronArrow />
    </Button>
  </div>
);
